import { Component, ComponentInterface, State, Method, Element, Prop, QueueApi, Watch, Listen, Event, EventEmitter, Host, h } from '@stencil/core';
import { Color, ComponentRef } from '../../../interface';
import { createColorClasses } from '../../../utils/theme';
import { config } from '../../../global/config';
@Component({
  tag: 'lar-video-modal',
  styleUrl: 'video-modal.scss',
  scoped: true
})

export class Modal implements ComponentInterface {
  @Element() el!: HTMLElement;

  // Reference to the user's provided modal content
  public presented = false;

  /**
   * The icon color to use from your application's color palette.
   * Default options are: `"primary"`, `"secondary"`, `"tertiary"`, `"success"`, `"warning"`, `"danger"`, `"light"`, `"medium"`, and `"dark"`.
   */
  @Prop() color?: Color;
  /**
   * Node main title
   */
  @Prop() mainTitle: string = '';

  // @TODO: animaation
  /**
   * Modal appearing animation if animations enabled
   * Default options are: `"bottom"`, `"right"`
   */
  // @Prop() animation: ('bottom' | 'right') = 'right';
   /**
    * Modal z-index
    */
  @Prop() overlayIndex?: number;
   /**
    * If `true`, a backdrop will be displayed behind the modal.
    */
  @Prop() showBackdrop = true;
   /**
    * If `true`, the modal will be dismissed when the backdrop is clicked.
    */
  @Prop() backdropDismiss = true;
  /**
   * Emitted before the modal has presented.
   */
  @Event({ eventName: 'larmodalwillpresent' }) willPresent!: EventEmitter;

  /**
   * Emitted after the modal has presented.
   */
  @Event({ eventName: 'larmodaldidpresent' }) didPresent!: EventEmitter;

  /**
   * Emitted before the modal has dismissed.
   */
  @Event({ eventName: 'larmodalwilldismiss' }) willDismiss!: EventEmitter;

  /**
   * Emitted after the modal has dismissed.
   */
  @Event({ eventName: 'larmodaldiddismiss' }) didDismiss!: EventEmitter;

  /**
   * The component to display inside of the modal.
   */
  @Prop() component?: ComponentRef;

  @Listen('larbackdroptap')
  protected onBackdropTap() {
    if (this.backdropDismiss) {
      this.dismiss();
    }
  }

  /**
   * Present the modal overlay after it has been created.
   */
  @Method()
  async present(video: HTMLVideoElement | HTMLCanvasElement): Promise<void> {
    if (this.presented) {
      return;
    }
    // Wait for component to render before querying DOM
    await new Promise(resolve => requestAnimationFrame(resolve));
    const container = this.el.querySelector(`.lar-modal-components-slot`);
    if (!container) {
      throw new Error('container is undefined');
    }
    this.willPresent.emit();
    container.appendChild(video);
    this.presented = true;
    this.didPresent.emit();
  }

   /**
    * Present the modal overlay after it has been created.
    */
  @Method()
  async dismiss(): Promise<void> {
    if (this.presented) {
      this.willDismiss.emit();
      this.didDismiss.emit();
    }
  }

  render() {
    return (
      <Host
        class={{ ...createColorClasses(this.color), 'lar-modal': true }}
        style={{
          'zIndex': String(200 + (this.overlayIndex || 0)),
        }}
      >
        <lar-backdrop visible={this.showBackdrop} tappable={this.backdropDismiss}/>
        <div role="dialog" onClick={() => this.dismiss()} class="lar-video-modal-wrapper">
          <div class="lar-video-modal-content">
            <div class="lar-modal-components-slot" />
            <h3>{this.mainTitle}</h3>
            <div class="tapinfo"><lar-translate t={'cam.tap_to_exit_fullscreen'} /></div>
          </div>
        </div>
      </Host>
    );
  }
}
